// eslint-disable-next-line import/no-default-export -- deprecated usage
export { Modal as default } from "./Modal";
